import { UploadTarget } from "@/hooks/useFileRecordUpload";
import { DestinationSheet } from "./DestinationSheet";

interface UploadTargetSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Called with the chosen destination; the sheet closes itself. */
  onSelect: (target: UploadTarget) => void;
  fileCount?: number;
}

/**
 * Bottom sheet to pick where mobile uploads land: a workspace (root) or a
 * canvas inside it. Thin wrapper over DestinationSheet (shared with the voice
 * flows) that keeps the upload-specific labels and props stable for callers.
 */
export function UploadTargetSheet({
  open,
  onOpenChange,
  onSelect,
  fileCount,
}: UploadTargetSheetProps) {
  const title = `Upload ${
    fileCount ? `${fileCount} file${fileCount > 1 ? "s" : ""}` : "files"
  } to…`;
  return (
    <DestinationSheet
      open={open}
      onOpenChange={onOpenChange}
      onSelect={onSelect}
      title={title}
      workspaceActionLabel="Upload to workspace"
    />
  );
}
